module.exports = __webpack_public_path__ + "static/media/shopping-cart.eaecfee4.svg";